module.exports = __webpack_public_path__ + "static/media/timeline-1.5a5f07f7.png";